import { render, staticRenderFns } from "./serverRecord.vue?vue&type=template&id=d13b7352&scoped=true&"
import script from "./serverRecord.vue?vue&type=script&lang=js&"
export * from "./serverRecord.vue?vue&type=script&lang=js&"
import style0 from "./serverRecord.vue?vue&type=style&index=0&id=d13b7352&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b7352",
  null
  
)

export default component.exports